import { useState, useEffect } from 'react';

import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';

import RefreshIcon from '@mui/icons-material/Refresh';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import { Chart } from "react-google-charts";
import { parseHTML, parseJSON } from 'jquery';

const TeamInsightRG_MLB = ({ teamid, firstTeam, teamOptions }) => {
    
    const [cmpSrid, setCmpSrid] = useState('')

    const [teamAData, setTeamAData] = useState([])

    const [data, setData] = useState([])
    const [options, setOptions] = useState([])

    const [selectedColumn, setSelectedColumn] = useState(-1)
    const [selectedLabel, setSelectedLabel] = useState('')
    const [leaderboards, setLeaderboards] = useState([])

    const [cmpLeaderboards, setCmpLeaderboards] = useState([])

    const [anchorEl, setAnchorEl] = useState(null)

    const [selectedChart, setSelectedChart] = useState('bar')

    const [barData, setBarData] = useState([])
    const [barOptions, setBarOptions] = useState([])

    const [compareChart, setCompareChart] = useState([])
    const [compareChartOptions, setCompareChartOptions] = useState([])

    const [selectedOppTeamId, setSelectedOppTeamId] = useState(0)

    const [notes, setNotes] = useState([])

    const [teamStrJson, setTeamStrJson] = useState(null)

    const listEppa = ["SP", "RP", "D", "C", "H", "BR", "LT"]

    const [show, setShow] = useState(false);

    const [loading, setLoading] = useState(true);

    const handleGlossaryModalClose = () => setShow(false)
    const handleShow = () => setShow(true);

    const epaHeaders = [
        {
            name: "PO-PD",
            col_att: "PASS ATTEMPTS",
            col_epa: "EPA/ATTEMPT"
        },
        {
            name: "RO-RD",
            col_att: "RUSH ATTEMPTS",
            col_epa: "EPA/RUSH"
        },
        {
            name: "ST-LT",
            col_att: "PLAYS",
            col_epa: "EPA/PLAY"
        }
    ]

    const handleResize = () => {
        LoadLineChart()
    }

    const sanitizeHtml = (html) => {
        return html
            .replace(/''/g, "'")  
            .replace(/""/g, '"')  
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, "'");
    };

    // Debouncing the LoadLineChart function
    useEffect(() => {
        // Set a debounce timer
        const debounceTimer = setTimeout(() => {
            LoadLineChart(); // Call your chart loading function
        }, 1000); // Adjust debounce time (e.g., 1000ms or 1 second)

        // Clean up the timeout when the effect re-runs or component unmounts
        return () => clearTimeout(debounceTimer);
    }, []); // No dependency array, runs only once on mount

    //useEffect(() => {

    //    LoadLineChart();

    //    //window.addEventListener('resize', handleResize)
    //    //return () => window.removeEventListener('resize', handleResize);

    //}, []);

    const LoadLineChart = () => {
        setLoading(true); // Start loading
        setData([])

        loadData(teamid)
            .then(function (d) {
                setTeamStrJson(d.MyIE_TeamPage);

                const tsw = d.MyIE_TeamPage?.find(x => x.TeamId === teamid);
                const epaJson = JSON.parse(tsw.TeamStrengthWeaknesses_EPA)?.find(x => x.team === teamid);
                const leaderboardsJson = JSON.parse(tsw.TeamStrengthWeaknesses_Leaderboards)
                let notesJson = JSON.parse(tsw.TeamStrengthWeaknesses_Notes)

                notesJson.forEach(item => {
                    let decodedNote = new DOMParser().parseFromString(item.note, 'text/html').documentElement.textContent;
                    item.note = decodedNote;
                });

                
                console.log("epaJson", epaJson)
                
                setTeamAData(epaJson)
                setLeaderboards(leaderboardsJson)
                
                drawData(epaJson)
                setNotes(notesJson)

                setLoading(false);

                //setTeamAData(d.Epa)   //// from table
                //setLeaderboards(d.Leaderboards) //// from table
                /*setNotes(d.Notes)*/
                //drawData(d.Epa) //// from table

            })
            .catch(function (e) {
                setLoading(false);
                console.log(e)
            })

    }

    const loadData = async (tmId) => {

        return new Promise((resolve, reject) => {
            fetch(`/MLB/EPA?teamid=${tmId}`).then(response => {
                if (response.ok) {
                    resolve(response.json())
                } else {
                    reject(new Error('error'))
                }
            }, error => {
                reject(new Error(error.message))
            })
        })

    }

    const onTeamChange = (event) => {

        const tmValue = event.target.value

        const tmName = event.target.selectedOptions[0].getAttribute('tmName')

        setCmpSrid(event.target.selectedOptions[0].getAttribute('srid'))

        const cmpColor1 = event.target.selectedOptions[0].getAttribute('color1')
        const cmpColor2 = event.target.selectedOptions[0].getAttribute('color2')

        setCompareChart([])
        setSelectedOppTeamId(tmValue)

        TmCompChart(tmValue, tmName, cmpColor1, cmpColor2)
    };

    const drawData = (epa) => {

        /////// Line Chart

        let eppArr = []

        eppArr.push(

            { name: "SP", value: epa?.SP, yAxis: 1, order: 0 },
            { name: "RP", value: epa?.RP, yAxis: 1, order: 1 },
            { name: "D", value: epa?.D, yAxis: 1, order: 2 },
            { name: "C", value: epa?.C, yAxis: 1, order: 3 },
            { name: "H", value: epa?.H, yAxis: 1, order: 4 },
            { name: "BR", value: epa?.BR, yAxis: 1, order: 5 },
            { name: "LT", value: epa?.LT, yAxis: 1, order: 6 },
        )

        eppArr.sort((a, b) => a.value - b.value)

        //console.log(eppArr.sort((a, b) => a.value - b.value))

        let next

        let prev

        let curr

        let diff

        let yEppa = 2

        for (let x = 0; x <= eppArr.length - 1; x++) {

            if (eppArr.length - 1 !== x) {

                next = eppArr[x + 1].value

                curr = eppArr[x].value

                diff = Math.abs(curr - next)

                if (diff <= 5) {
                    yEppa += 2
                    eppArr[x + 1].yAxis = yEppa
                }
                else {
                    yEppa = 1
                }

            }
        }

        eppArr.sort((a, b) => a.order - b.order)

        const d = [
            [
                { label: "vale", type: "number" }, { label: "vale", type: "number" }, { role: "annotation", type: "string" }
            ],
            [eppArr[0].value, eppArr[0].yAxis, eppArr[0].name],
            [eppArr[1].value, eppArr[1].yAxis, eppArr[1].name],
            [eppArr[2].value, eppArr[2].yAxis, eppArr[2].name],
            [eppArr[3].value, eppArr[3].yAxis, eppArr[3].name],
            [eppArr[4].value, eppArr[4].yAxis, eppArr[4].name],
            [eppArr[5].value, eppArr[5].yAxis, eppArr[5].name],
            [eppArr[6].value, eppArr[6].yAxis, eppArr[6].name]
        ]

        const o = {

            series: {
                0: { tooltip: false }, // disable tooltip

            },
            annotations: {
                stem: {
                    length: -5
                },
                textStyle: {

                    fontSize: 10,
                    bold: true,
                    // The color of the text.
                    color: 'white',
                    // The color of the text outline.
                    auraColor: 'transparent',
                    // The transparency of the text.
                    opacity: 1
                }
            },
            dataLoadingStatus: 'ready',
            hAxis: {
                /*ticks: [0, 25, 50, 75, 100],*/
                ticks: [
                    { v: 0, f: '0\nWorst' },
                    { v: 25, f: '25' },
                    { v: 50, f: '50\nMiddle of the Pack' },
                    { v: 75, f: '75' },
                    { v: 100, f: '100\nBest' }
                ],
                textPosition: 'out',
                textStyle: {
                    fontName: 'Arial',
                    fontSize: '12'
                },

            },
            vAxis: {
                textPosition: 'none',
                title: firstTeam.name,

                lineWidth: 5,
                textStyle: {
                    fontName: 'Arial',
                    fontSize: '24'
                },
                minValue: 2, maxValue: 15
            },
            legend: 'none',
            colors: ['black'],
            pointSize: 20,

            chartArea: { width: '90%' },
        };

        setData(d)
        setOptions(o)

        //// BarChart
        const bd = [
            [{ 'type': 'string' }, { 'type': 'number' }, { role: 'annotation' }, { role: 'style' }],
            ["SP", epa.SP, epa.SP, `stroke-width: 2;stroke-color: ${firstTeam.color2}`],
            ["RP", epa.RP, epa.RP, `stroke-width: 2;stroke-color: ${firstTeam.color2}`],
            ["D", epa.D, epa.D, `stroke-width: 2;stroke-color: ${firstTeam.color2}`],
            ["C", epa.C, epa.C, `stroke-width: 2;stroke-color: ${firstTeam.color2}`],
            ["H", epa.H, epa.H, `stroke-width: 2;stroke-color: ${firstTeam.color2}`],
            ["BR", epa.BR, epa.BR, `stroke-width: 2;stroke-color: ${firstTeam.color2}`],
            ["LT", epa.LT, epa.LT, `stroke-width: 2;stroke-color: ${firstTeam.color2}`],
        ];
        const bdo = {

            chartArea: { width: '90%' },
            colors: [firstTeam.color1],
            bar: { groupWidth: "35%" },
            vAxis: {
                lineWidth: 5,
                textStyle: {
                    fontName: 'Arial',
                    fontSize: '16'
                }
            },
            legend: 'none',
        };

        setBarOptions(bdo)
        setBarData(bd)
    }

    const TmCompChart = (tmId, oppTeam, cmpColor1, cmpColor2) => {

        const tsw = teamStrJson?.find(x => Number(x.TeamId) === Number(tmId));

        const epaJson = JSON.parse(tsw.TeamStrengthWeaknesses_EPA)?.find(x => Number(x.team) === Number(tmId));
        const leaderboardsJson = JSON.parse(tsw.TeamStrengthWeaknesses_Leaderboards)
        let notesJson = JSON.parse(tsw.TeamStrengthWeaknesses_Notes)

        notesJson.forEach(item => {
            let decodedNote = new DOMParser().parseFromString(item.note, 'text/html').documentElement.textContent;
            item.note = decodedNote;
        });

        const oppData = epaJson
        setCmpLeaderboards(leaderboardsJson)

        //const oppData = d.Epa /// orig
        const epa = teamAData

        //setCmpLeaderboards(d.Leaderboards) // orig

        const comboData = [
            [
                { 'type': 'string' }, { 'type': 'number', label: firstTeam.name }, { role: 'annotation' }, { role: 'style' },
                { 'type': 'number', label: oppTeam }, { role: 'annotation' }, { role: 'style' }
            ],
            ["SP", epa.SP, epa.SP, `stroke-width: 2;stroke-color: ${firstTeam.color2}`, oppData.SP, oppData.SP, `stroke-width: 2;stroke-color: ${cmpColor2}`],
            ["RP", epa.RP, epa.RP, `stroke-width: 2;stroke-color: ${firstTeam.color2}`, oppData.RP, oppData.RP, `stroke-width: 2;stroke-color: ${cmpColor2}`],
            ["D", epa.D, epa.D, `stroke-width: 2;stroke-color: ${firstTeam.color2}`, oppData.D, oppData.D, `stroke-width: 2;stroke-color: ${cmpColor2}`],
            ["C", epa.C, epa.C, `stroke-width: 2;stroke-color: ${firstTeam.color2}`, oppData.C, oppData.C, `stroke-width: 2;stroke-color: ${cmpColor2}`],
            ["H", epa.H, epa.H, `stroke-width: 2;stroke-color: ${firstTeam.color2}`, oppData.H, oppData.H, `stroke-width: 2;stroke-color: ${cmpColor2}`],
            ["B", epa.BR, epa.BR, `stroke-width: 2;stroke-color: ${firstTeam.color2}`, oppData.BR, oppData.BR, `stroke-width: 2;stroke-color: ${cmpColor2}`],
            ["LT", epa.LT, epa.LT, `stroke-width: 2;stroke-color: ${firstTeam.color2}`, oppData.LT, oppData.LT, `stroke-width: 2;stroke-color: ${cmpColor2}`],
        ];

        const comboDataOptions = {
            colors: [firstTeam.color1, cmpColor1],
            chartArea: {
                width: '90%'
            },
            bar: { groupWidth: "70%" },
            legend: { position: 'bottom' },
            vAxis: {

                lineWidth: 5,
                textStyle: {
                    fontName: 'Arial',
                    fontSize: '16'
                }
            },


        };

        setCompareChart(comboData)
        setCompareChartOptions(comboDataOptions)
    }

    const TmCompChartXX = (tmId, oppTeam, cmpColor1, cmpColor2) => {

        loadData(tmId)
            .then(function (d) {


                setTeamStrJson(d.MyIE_TeamPage)
                const epaJson = JSON.parse(d.MyIE_TeamPage.TeamStrengthWeaknesses_EPA)?.find(x => x.team === tmId);
                const leaderboardsJson = JSON.parse(d.MyIE_TeamPage.TeamStrengthWeaknesses_Leaderboards)
                let notesJson = JSON.parse(d.MyIE_TeamPage.TeamStrengthWeaknesses_Notes)

                notesJson.forEach(item => {
                    let decodedNote = new DOMParser().parseFromString(item.note, 'text/html').documentElement.textContent;
                    item.note = decodedNote;
                });
                
                const oppData = epaJson
                setCmpLeaderboards(leaderboardsJson)

                //const oppData = d.Epa /// orig
                const epa = teamAData

                //setCmpLeaderboards(d.Leaderboards) // orig

                const comboData = [
                    [
                        { 'type': 'string' }, { 'type': 'number', label: firstTeam.name }, { role: 'annotation' }, { role: 'style' },
                        { 'type': 'number', label: oppTeam }, { role: 'annotation' }, { role: 'style' }
                    ],
                    ["SP", epa.SP, epa.SP, `stroke-width: 2;stroke-color: ${firstTeam.color2}`, oppData.SP, oppData.SP, `stroke-width: 2;stroke-color: ${cmpColor2}`],
                    ["RP", epa.RP, epa.RP, `stroke-width: 2;stroke-color: ${firstTeam.color2}`, oppData.RP, oppData.RP, `stroke-width: 2;stroke-color: ${cmpColor2}`],
                    ["D", epa.D, epa.D, `stroke-width: 2;stroke-color: ${firstTeam.color2}`, oppData.D, oppData.D, `stroke-width: 2;stroke-color: ${cmpColor2}`],
                    ["C", epa.C, epa.C, `stroke-width: 2;stroke-color: ${firstTeam.color2}`, oppData.C, oppData.C, `stroke-width: 2;stroke-color: ${cmpColor2}`],
                    ["H", epa.H, epa.H, `stroke-width: 2;stroke-color: ${firstTeam.color2}`, oppData.H, oppData.H, `stroke-width: 2;stroke-color: ${cmpColor2}`],
                    ["B", epa.BR, epa.BR, `stroke-width: 2;stroke-color: ${firstTeam.color2}`, oppData.BR, oppData.BR, `stroke-width: 2;stroke-color: ${cmpColor2}`],
                    ["LT", epa.LT, epa.LT, `stroke-width: 2;stroke-color: ${firstTeam.color2}`, oppData.LT, oppData.LT, `stroke-width: 2;stroke-color: ${cmpColor2}`],
                ];

                const comboDataOptions = {
                    colors: [firstTeam.color1, cmpColor1],
                    chartArea: {
                        width: '90%'
                    },
                    bar: { groupWidth: "70%" },
                    legend: { position: 'bottom' },
                    vAxis: {

                        lineWidth: 5,
                        textStyle: {
                            fontName: 'Arial',
                            fontSize: '16'
                        }
                    },


                };

                setCompareChart(comboData)
                setCompareChartOptions(comboDataOptions)

            })
            .catch(function (e) {
                console.log(e)
            })

    }

    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const chartEvents = [
        {
            eventName: "ready",
            callback: ({ chartWrapper, google }) => {
                const chart = chartWrapper.getChart();

                google.visualization.events.addListener(chart, 'select', e => {

                    var selectedItem = chart.getSelection()[0];

                    if (selectedItem) {

                        setSelectedColumn(selectedItem.column)

                        setSelectedLabel(listEppa[selectedItem.row])

                        handleClick(chart.container)

                    }
                });
            }
        }
    ];

    const FilterEpa = () => {
        //// 1 = main team /// 3 = compare to team
        const lboards = selectedColumn === 1 || selectedColumn === 2 ? leaderboards : cmpLeaderboards

        var dataLeaderboards = lboards?.filter(x => x.Label === selectedLabel).sort((a, b) => a.Rank - b.Rank)

        return RankColorShades(dataLeaderboards)

    }

    const RankColorShades = (model) => {

        let cRed = "#f8696b"
        let cBlue = '#5a8ac6'

        const ColorShading = (d, col) => {

            let amt = 9

            var usePound = false;

            if (col[0] == "#") {
                col = col.slice(1);
                usePound = true;
            }

            d.forEach((val, idx) => {

                val.RO = 2;
                val.PO = 2;
                val.RD = 2;
                val.RD = 2;
                val.LT = 2;
                val.ST = 2;

                if (idx === 0) {
                    val.BackgroundColor = `#${col}`
                }
                else {
                    var R = parseInt(col.substring(0, 2), 16);
                    var G = parseInt(col.substring(2, 4), 16);
                    var B = parseInt(col.substring(4, 6), 16);

                    R = R + amt;
                    G = G + amt;
                    B = B + amt;

                    if (R > 255) R = 255;
                    else if (R < 0) R = 0;

                    if (G > 255) G = 255;
                    else if (G < 0) G = 0;

                    if (B > 255) B = 255;
                    else if (B < 0) B = 0;

                    let RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
                    let GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
                    let BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));

                    val.BackgroundColor = "#" + RR + GG + BB;

                    col = RR + GG + BB;
                }

            });

        }

        ///// red 1-16        
        ColorShading(model.slice(0, 15).sort((a, b) => a.Rank - b.Rank), cRed)

        ///// blue 17-32
        ColorShading(model.slice(15, 30).sort((b, a) => a.Rank - b.Rank), cBlue)

        //// sort to original
        return model.sort((a, b) => a.Rank - b.Rank)

    }

    if (data.length === 0) {

        return (
            <div className="w-100 text-center p-5">
                <Box>
                    <CircularProgress />
                </Box>
            </div>
        )

    }

    return (
        <>
            <Container className="p-0">
                <Row id="legendChart" style={{ fontSize: "14px" }}>
                    <Col lg={12} className="text-center mb-4 d-none hidden">

                        <button
                            onClick={() => setSelectedChart('line')}
                            className={`btn btn-sm btn-outline-dark me-1 ${selectedChart === 'line' ? 'active' : ''}`}
                        >
                            Line Chart
                        </button>
                        <button
                            onClick={() => setSelectedChart('bar')}
                            className={`btn btn-sm btn-outline-dark me-1 ${selectedChart === 'bar' ? 'active' : ''}`}
                        >
                            Bar Chart
                        </button>

                        <button
                            onClick={() => LoadLineChart()}
                            className="btn btn-sm btn-light float-end"
                        >
                            <RefreshIcon />
                        </button>

                    </Col>

                    {
                        selectedChart === "bar"
                            ?
                            <Col lg={12} className="pb-4">
                                <span>Compare Team: </span>
                                <Form.Select
                                    id="compDropDown"
                                    onChange={(e) => onTeamChange(e)}
                                    size="sm" value={selectedOppTeamId}
                                    aria-label="Default select"
                                    className="w-50 d-inline px-3"
                                >

                                    <option value="0">Select Team</option>

                                    {teamOptions.map((i, index) => (
                                        <option
                                            key={i.value}
                                            value={i.value}
                                            srid={i.srid}
                                            tmname={i.tmName}
                                            color1={i.color1}
                                            color2={i.color2}
                                        >
                                            {i.text}
                                        </option>
                                    ))}

                                </Form.Select>
                            </Col>
                            : <></>

                    }

                    <Col lg={4}><b>SP</b> = Starting Pitching</Col>
                    <Col lg={4}><b>RP</b> = Relief Pitching</Col>
                    <Col lg={4}><b>D</b> = Defense</Col>
                    <Col lg={4}><b>C</b> = Catching</Col>
                    <Col lg={4}><b>H</b> = Hitting</Col>
                    <Col lg={4}><b>BR</b> = Baserunning</Col>
                    <Col lg={4}><b>LT</b> = Little Things</Col>
                    <Col lg={12} className="text-center bg-light">
                        <button
                            onClick={handleShow}
                            type="button"
                            className="btn btn-link btn-md"
                            title="Glossary">
                            Glossary
                        </button>
                    </Col>
                </Row>

                {
                    data?.length !== 0 && selectedChart === "line"
                        ?
                        <>

                            <Chart
                                className="w-100"
                                chartType="ScatterChart"
                                data={data}
                                options={options}
                                chartEvents={chartEvents}
                            />

                        </>
                        :
                        <div>

                            {
                                Number(selectedOppTeamId) === teamid || Number(selectedOppTeamId) === 0
                                    ?
                                    !loading 
                                        ?
                                        <Chart
                                            chartType="ColumnChart"
                                            width="100%"
                                            height="300px"
                                            data={barData}
                                            options={barOptions}
                                            chartEvents={chartEvents}
                                        />
                                        :
                                        <div className="w-100 text-center p-5">
                                            <Box>
                                                <CircularProgress />
                                            </Box>

                                        </div>
                                    :
                                    compareChart.length !== 0
                                        ?
                                        <>
                                            <Chart
                                                className="p-0"
                                                chartType="ColumnChart"
                                                width="100%"
                                                height="300px"
                                                data={compareChart}
                                                options={compareChartOptions}
                                                chartEvents={chartEvents}
                                            />
                                        </>
                                        :
                                        <div className="w-100 text-center p-5">
                                            <Box>
                                                <CircularProgress />
                                            </Box>
                                        </div>
                            }


                        </div>

                }

                <div className="card my-4 border-0">

                    <div className="card-header border-1">
                        Team Insights (powered by Remarkable)
                    </div>

                    <div className="card-body px-0">
                        <ul id="epa_notes">

                            {
                                notes?.map((item, idx) => {

                                    return (
                                        <li className="my-2" key={`note_${idx}`} dangerouslySetInnerHTML={{ __html: sanitizeHtml(item.note) }} />

                                    )

                                })
                            }

                        </ul>
                    </div>

                </div>

            </Container>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                PaperProps={{
                    style: { height: '50%' },
                }}
            >
                <Typography sx={{ p: 2 }}>
                    <table className="pnlLeaderboards table table-lg text-center">
                        <caption
                            className='pnlClose p-0'
                            style={{ captionSide: "top", fontWeight: "bold", padding: "0px 10px" }}
                            onClick={() => handleClose()}
                        >
                            <div className="row">
                                <div className="col text-center text-secondary border">{selectedLabel}</div>
                                <div className="col text-end">X</div>
                            </div>

                        </caption>
                        <thead>
                            <tr>
                                <td>RANK</td>
                                <td className="text-start">TEAM</td>
                                <td>Value</td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                FilterEpa()?.map((d, i) => {

                                    return (

                                        <tr
                                            key={d.TeamName}
                                            style={d.TeamName === (selectedColumn === 1 || selectedColumn === 2 ? firstTeam.srid : cmpSrid) ? { backgroundColor: '#ffff99', border: '2px solid #C8C8C8' } : {}}
                                        >
                                            <td>{d.Rank}</td>
                                            <td className="text-start">{d.TeamName}</td>
                                            <td
                                                style={{ backgroundColor: d.BackgroundColor }}
                                            >
                                                {d.Value.toFixed(0)}
                                            </td>
                                        </tr>

                                    )

                                })
                            }
                            <tr className="text-center">
                                <td colSpan="4" className="border-0">
                                    <button
                                        onClick={() => handleClose()}
                                        className='btn pnlClose p-2 border-0'
                                    >
                                        Close
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Typography>
            </Popover>

            <div className={`modal ${show ? 'show' : ''}`} tabIndex="-1" role="dialog" style={{ display: show ? 'block' : 'none' }} onBlur={handleGlossaryModalClose} data-bs-backdrop="static">
                <div className="modal-dialog modal-lg shadow-lg" role="document">
                    <div className="modal-content modal-light">
                        <div className="modal-header text-center">
                            <h5 className="modal-title fw-bolder">Glossary</h5>
                            <button type="button" className="btn-close" onClick={handleGlossaryModalClose} aria-label="Close"></button>
                        </div>
                        <div className="modal-body p-3">

                            <p>
                                Inside Edge scouts analyze every play of every MLB game, capturing detail far beyond the basic
                                game state transitions found in conventional run models. Rich data enables a more precise estimate of run
                                potential compared to simple league averages. Greater probabilistic precision makes our new Expected Runs
                                Added metric the most accurate assessment of team strength available to the public.
                            </p>

                            <p>
                                <b>Here's how each game dimension is defined:</b>
                            </p>

                            <p>
                                <b>Hitting </b>
                                <span> Expected runs added by batters at the plate. The stat is total expected runs above or below the league average for an identical mix of base-out game states. Positive values are better.</span>
                            </p>

                            <p>
                                <b>Pitching  </b>
                                <span>Expected runs prevented on pitches. The stat is total expected runs above or below the league average for an identical mix of base-out game states. Negative values are better.</span>
                            </p>
                            <p>
                                <b>Relief Pitching</b>
                                <span>Expected runs prevented by relievers.</span>
                            </p>
                            <p>
                                <b>Defense  </b>
                                <span>Expected runs prevented on defensive plays, including by pitchers and catchers. The stat is total expected runs above or below the league average for an identical mix of base-out game states. Negative values are better.</span>
                            </p>

                            <p>
                                <b>Baserunning  </b>
                                <span>Expected runs added on the basepaths by hitting teams.  The stat is total expected runs above or below the league average for an identical mix of base-out game states. Positive values are better.</span>
                            </p>

                            <p>
                                <b>Catching  </b>
                                <span>Pitch framing performance. Measures the number of strikes won on "striballs” compared to the league average expectation. Striballs are pitch locations around the edge of the zone. Not an expected runs stat.</span>
                            </p>

                            <p>
                                <b>Little Things </b>
                                <span>Intangibles are impossible to quantify, yet they provide insight into quality of play. The stat is the net positive count of a team's Little Things. Not an expected runs stat.</span>
                            </p>

{/*                            <p className="fw-italic">* Inside Edge's new expected runs metric is a strengthened version of runs probability that uses richer data.</p>*/}

                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={handleGlossaryModalClose}>Close</button>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )

}

export default TeamInsightRG_MLB
